module.exports = __webpack_public_path__ + "img/Drying_stock.2c6715fa.svg";